__turbopack_context__.v({
  "className": "ajbm2q_className",
  "variable": "ajbm2q_variable",
});
